import React from 'react';
import Input from "../Input-new/Input";
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";
import Textarea from "../Textarea-new/Textarea";
import Control from "../Control";
import SelectTeam from '../SelectTeam-new/SelectTeam';
import { getTenantSubcategoryMT, getTenantSubcategorySTNL } from '../../utils';

const SellerForm = ({theme = 'white', data, paneIndex, isFilter = false, handleSubmit, handleCancel, handleParentChange, handleParentDropdownChange, handlePaneChange}) => {
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Seller' : 'Add Seller'}</div>
                <Input theme={theme}
                       valueType='text'
                       name='first_name'
                       label='First Name'
                       value={data.first_name}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='last_name'
                       label='Last Name'
                       value={data.last_name}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='phone'
                       name='phone'
                       label='Phone'
                       value={data.phone}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType={isFilter ? 'text' : 'email'}
                       name='email'
                       label='Email'
                       value={data.email}
                       handleParentChange={handleParentChange}
                />
                <Dropdown theme={theme}
                          optionsType='profiles'
                          value={data.profile}
                          valueKey='profile'
                          label='Profile'
                          data={data}
                          handleParentChange={handleParentDropdownChange}
                />
                <Dropdown theme={theme}
                          optionsType='sellerStatus'
                          value={data.status}
                          valueKey='status'
                          label='Seller Status'
                          data={data}
                          handleParentChange={handleParentDropdownChange}
                />
                {
                    !isFilter &&   
                    // <div className='last-modified'>Last modified on: {data.LAST_MODIFIED}</div>      
                    <div className='last-modified'>Last modified on: {data.last_modified}</div>
                }
                <Textarea theme={theme}
                        name='notes'
                        label='Notes'
                        value={data.notes}
                        maxWidth='100%'
                        handleParentChange={handleParentChange}
                />
            </React.Fragment>
        ),
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Seller Company' : 'Add Seller Company'}</div>
                <Input theme={theme}
                       valueType='text'
                       name='company_name'
                       label='Company Name'
                       value={data.company_name}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='company_address'
                       label='Company Address'
                       value={data.company_address}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='company_city'
                       label='City'
                       value={data.company_city}
                       handleParentChange={handleParentChange}
                />
                <div className='form-address'>
                    <div className='form-state'>
                        <Dropdown theme={theme}
                                  optionsType='states'
                                  optionKey='abbr'
                                  optionLabelKey='name'
                                  value={data.company_state}
                                  valueKey='company_state'
                                  label='State'
                                  data={data}
                                  handleParentChange={handleParentDropdownChange}
                        />
                    </div>
                    <div className='form-zip'>
                        <Input theme={theme}
                               valueType='text'
                               name='company_zip'
                               label='Zip'
                               value={data.company_zip}
                               handleParentChange={handleParentChange}
                        />
                    </div>
                </div>
            </React.Fragment>
        ),
    ];

    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                {
                    panes.map((el, key) => (
                        <Control key={key} onClick={()=> handlePaneChange(key)}>
                            <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                        </Control>
                    ))
                }
            </div>
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

SellerForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    data: PropTypes.object.isRequired,
    paneIndex: PropTypes.number.isRequired,
    isFilter: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
    handlePaneChange: PropTypes.func.isRequired,
};

export default SellerForm;